/**
 * DoozyBot chat sound effect — plays royalty-free "boop" on open & new messages.
 * Sound file served from /public/sounds/c_boop.wav (generated from scratch via sine waves,
 * no samples/copyrighted audio — fully royalty-free).
 */
let audioCtx = null;
let boopBuffer = null;
let loadingPromise = null;

const SOUND_URL = "/sounds/c_boop.wav";

function getCtx() {
  if (audioCtx) return audioCtx;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return null;
    audioCtx = new Ctx();
  } catch (err) {
    console.warn('[sound] AudioContext init failed:', err);
    return null;
  }
  return audioCtx;
}

async function loadBoop() {
  if (boopBuffer) return boopBuffer;
  if (loadingPromise) return loadingPromise;
  const ctx = getCtx();
  if (!ctx) return null;
  loadingPromise = (async () => {
    try {
      const res = await fetch(SOUND_URL);
      const arr = await res.arrayBuffer();
      boopBuffer = await ctx.decodeAudioData(arr);
      return boopBuffer;
    } catch (err) {
      console.warn('[sound] boop load failed:', err);
      return null;
    }
  })();
  return loadingPromise;
}

/**
 * Play the boop sound. Silently no-ops if user hasn't interacted yet
 * (browser autoplay policy) or audio fails to load.
 */
export async function playBoop(volume = 0.5) {
  // Honor user preference
  try {
    if (localStorage.getItem("doozybot_sound_muted") === "1") return;
  } catch (e) {
    // Private mode / storage disabled — fall through and play the sound.
    // No user-facing impact; log for debugging only.
    console.debug("[DoozyBotSound] localStorage read blocked:", e?.message);
  }
  const ctx = getCtx();
  if (!ctx) return;
  if (ctx.state === "suspended") {
    try { await ctx.resume(); } catch { return; }
  }
  const buf = await loadBoop();
  if (!buf) return;
  try {
    const src = ctx.createBufferSource();
    src.buffer = buf;
    const gain = ctx.createGain();
    gain.gain.value = Math.max(0, Math.min(1, volume));
    src.connect(gain).connect(ctx.destination);
    src.start(0);
  } catch (err) {
    // Browser may reject playback for various reasons (suspended ctx, GC'd buffer).
    // Log so we notice if a regression starts dropping every audio cue.
    console.warn('[sound] boop playback failed:', err);
  }
}

export function isSoundMuted() {
  try { return localStorage.getItem("doozybot_sound_muted") === "1"; } catch { return false; }
}

export function toggleSoundMuted() {
  try {
    const cur = localStorage.getItem("doozybot_sound_muted") === "1";
    localStorage.setItem("doozybot_sound_muted", cur ? "0" : "1");
    return !cur;
  } catch { return false; }
}
